<template>
  <!--  FEATURES TABS  -->

  <section class="mx-auto mt-[145px] max-w-[1140px] px-[25px] xl:px-0">
    <div class="text-left">
      <div
        id="text_email_integrations"
        class="text-xs font-bold tracking-wide text-[#2D8CFF] text-center"
      >
        FEATURES
      </div>

      <h2
        class="px-auto top-full text-center mt-[20px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
      >
        Stream without limits.
      </h2>
    </div>

    <div class="flex flex-wrap mt-10">
      <div class="w-full lg:flex">
        <ul class="mb-0 list-none pt-3 pb-4">
          <li
            class="mr-2 last:mr-0 flex-auto text-left lg:w-[432px] lg:h-[45px] my-[10px]"
          >
            <a
              class="text-xl font-bold uppercase px-5 py-3 block leading-normal cursor-pointer"
              v-on:click="toggleTabs(1)"
              v-bind:class="{
                'text-[#B9BEC7] hover:text-[#7c828d] hover:ease-in-out border-l-2 border-[#f1f3fa]':
                  openTab !== 1,
                'text-[#292d34] border-l-4 border-[#2D8CFF] ease-in your-way-tab':
                  openTab === 1
              }"
            >
              01. OBS Integration
            </a>
            <div
              class="quiz-card-1 lg:hidden mt-[15px]"
              v-bind:class="{
                hidden: openTab !== 1,
                'block shadow-xl shadow-[#2d8bff33] rounded-lg p-[30px] py-5 ':
                  openTab === 1
              }"
            >
              <img
                class="p-[20px]"
                :src="
                  $filters.media_path('/images/live-streaming-with-OBS.png')
                "
                alt="Stream live webinars to members using OBS."
              />
              <p class="mt-[25px] text-center text-lg text-white">
                Live stream using OBS Studio for to give followers the enhanced
                experience they are used to without compromising settings and
                backgrounds.
              </p>
            </div>
          </li>
          <li
            class="-mb-px mr-2 last:mr-0 flex-auto text-left lg:w-[432px] lg:h-[45px] my-[10px]"
          >
            <a
              class="text-xl font-bold uppercase px-5 py-3 block leading-normal cursor-pointer"
              v-on:click="toggleTabs(2)"
              v-bind:class="{
                'text-[#B9BEC7] hover:text-[#7c828d] hover:ease-in-out border-l-2 border-[#f1f3fa] ':
                  openTab !== 2,
                'text-[#292d34] border-l-4 border-[#FD71AF] ease-in your-way-tab':
                  openTab === 2
              }"
            >
              02. Super Chat
            </a>
            <div
              class="watch-card-2 lg:hidden mt-[15px]"
              v-bind:class="{
                hidden: openTab !== 2,
                'block shadow-xl shadow-[#2d8bff33] rounded-lg p-[30px] py-5 ':
                  openTab === 2
              }"
            >
              <img
                class="p-[20px]"
                :src="
                  $filters.media_path(
                    '/images/super-chat-with-members-live-in-your-course.png'
                  )
                "
                alt="Community live streaming chat."
              />

              <p class="mt-[25px] text-center text-lg text-white">
                Connect with fans directly with Platforma’s Super Chat. All
                registers can participate in the chat. Option to mute, ban, or
                slow roll the chat.
              </p>
            </div>
          </li>
          <li
            class="-mb-px mr-2 last:mr-0 flex-auto text-left lg:w-[432px] lg:h-[45px] my-[10px]"
          >
            <a
              class="text-xl font-bold uppercase px-5 py-3 block leading-normal cursor-pointer"
              v-on:click="toggleTabs(3)"
              v-bind:class="{
                'text-[#B9BEC7] hover:text-[#7c828d] hover:ease-in-out border-l-2 border-[#f1f3fa]':
                  openTab !== 3,
                'text-[#292d34] border-l-4 border-[#49CCF9] ease-in your-way-tab':
                  openTab === 3
              }"
            >
              03. Whiteboard
            </a>
            <div
              class="cert-card-3 lg:hidden mt-[15px]"
              v-bind:class="{
                hidden: openTab !== 3,
                'block shadow-xl shadow-[#2d8bff33] rounded-lg p-[30px] py-5 ':
                  openTab === 3
              }"
            >
              <img
                class="p-[20px]"
                :src="
                  $filters.media_path(
                    '/images/articulate-your-thoughts-with-whiteboard.png'
                  )
                "
                alt="Draw live on your screen during webinar."
              />

              <p class="mt-[25px] text-center text-lg text-white">
                Enrich the presentation by drawing a mind map, or simply writing
                descriptive annotations to drive the point home!
              </p>
            </div>
          </li>
          <li
            class="-mb-px mr-2 last:mr-0 flex-auto text-left lg:w-[432px] lg:h-[45px] my-[10px]"
          >
            <a
              class="text-xl font-bold uppercase px-5 py-3 block leading-normal cursor-pointer"
              v-on:click="toggleTabs(4)"
              v-bind:class="{
                'text-[#B9BEC7] hover:text-[#7c828d] hover:ease-in-out border-l-2 border-[#f1f3fa]':
                  openTab !== 4,
                'text-[#292d34] border-l-4 border-[#27AE60] your-way-tab':
                  openTab === 4
              }"
            >
              04. Active Offers
            </a>
            <div
              class="download-card-4 lg:hidden mt-[15px]"
              v-bind:class="{
                hidden: openTab !== 4,
                'block shadow-xl shadow-[#2d8bff33] rounded-lg p-[30px] py-5 ':
                  openTab === 4
              }"
            >
              <img
                class="p-[20px]"
                :src="
                  $filters.media_path(
                    '/images/live-offers-on-webinars-sell-live-to-members.png'
                  )
                "
                alt="Sell more digital products to members on live streams."
              />

              <p class="mt-[25px] text-center text-lg text-white">
                Convert your webinars into full-fledged money-making events with
                live offer displays.
              </p>
            </div>
          </li>
          <li
            class="-mb-px mr-2 last:mr-0 flex-auto text-left lg:w-[432px] lg:h-[45px] my-[10px]"
          >
            <a
              class="text-xl font-bold uppercase px-5 py-3 block leading-normal cursor-pointer"
              v-on:click="toggleTabs(5)"
              v-bind:class="{
                'text-[#B9BEC7] hover:text-[#7c828d] hover:ease-in-out border-l-2 border-[#f1f3fa]':
                  openTab !== 5,
                'text-[#292d34] border-l-4 border-[#FFC800] your-way-tab':
                  openTab === 5
              }"
            >
              05. Email Notifications
            </a>
            <div
              class="hide-course-card-5 lg:hidden mt-[15px]"
              v-bind:class="{
                hidden: openTab !== 5,
                'block shadow-xl shadow-[#2d8bff33] rounded-lg p-[30px] py-5 ':
                  openTab === 5
              }"
            >
              <img
                class="p-[20px]"
                :src="
                  $filters.media_path(
                    '/images/email-reminders-for-webinars.png'
                  )
                "
                alt="Members received notifications to your live stream."
              />

              <p class="mt-[25px] text-center text-lg text-white">
                Ensure great attendance rates with email reminders guaranteed to
                redirect registers to the show.
              </p>
            </div>
          </li>
          <li
            class="-mb-px mr-2 last:mr-0 flex-auto text-left lg:w-[432px] lg:h-[45px] my-[10px]"
          >
            <a
              class="text-xl font-bold uppercase px-5 py-3 block leading-normal cursor-pointer"
              v-on:click="toggleTabs(6)"
              v-bind:class="{
                'text-[#B9BEC7] hover:text-[#7c828d] hover:ease-in-out border-l-2 border-[#f1f3fa]':
                  openTab !== 6,
                'text-[#292d34] border-l-4 border-[#7B68EE] your-way-tab':
                  openTab === 6
              }"
            >
              06. Downloadable Replays
            </a>
            <div
              class="unlock-course-card-6 lg:hidden mt-[15px]"
              v-bind:class="{
                hidden: openTab !== 6,
                'block shadow-xl shadow-[#2d8bff33] rounded-lg p-[30px] py-5 ':
                  openTab === 6
              }"
            >
              <img
                class="p-[20px]"
                :src="
                  $filters.media_path(
                    '/images/downloadable-replays-of-the-live-stream.png'
                  )
                "
                alt="Download a replay of the live stream in your course."
              />

              <p class="mt-[25px] text-center text-lg text-white">
                If you activate the option, Platforma will automatically record
                your live broadcast in a video file for download and use.
              </p>
            </div>
          </li>
        </ul>

        <div
          class="hidden relative lg:flex flex-col min-w-0 break-words w-full mb-6 pt-3 rounded lg:h-[554px]"
        >
          <div class="flex-auto">
            <div class="tab-content tab-space">
              <div
                class="quiz-card-1"
                v-bind:class="{
                  hidden: openTab !== 1,
                  'block shadow-xl shadow-[#2d8bff33] rounded-lg p-[30px] py-5 ':
                    openTab === 1
                }"
              >
                <img
                  class="p-[20px] mx-auto max-w-[475px]"
                  :src="
                    $filters.media_path('/images/live-streaming-with-OBS.png')
                  "
                  alt="Connect OBS and stream your way"
                />
                <p class="mt-[25px] text-center text-lg text-white">
                  Live stream using OBS Studio for to give followers the
                  enhanced experience they are used to without compromising
                  settings and backgrounds.
                </p>
              </div>

              <div
                class="watch-card-2"
                v-bind:class="{
                  hidden: openTab !== 2,
                  'block shadow-xl shadow-[#2d8bff33] rounded-lg p-[30px] py-5 ':
                    openTab === 2
                }"
              >
                <img
                  class="p-[20px]"
                  :src="
                    $filters.media_path(
                      '/images/super-chat-with-members-live-in-your-course.png'
                    )
                  "
                  alt="Chat with members live in your course on a live streaming interface."
                />

                <p class="mt-[25px] text-center text-lg text-white">
                  Connect with fans directly with Platforma’s Super Chat. All
                  registers can participate in the chat. Option to mute, ban, or
                  slow roll the chat.
                </p>
              </div>

              <div
                class="cert-card-3"
                v-bind:class="{
                  hidden: openTab !== 3,
                  'block shadow-xl shadow-[#2d8bff33] rounded-lg p-[30px] py-5 ':
                    openTab === 3
                }"
              >
                <img
                  class="p-[20px]"
                  :src="
                    $filters.media_path(
                      '/images/articulate-your-thoughts-with-whiteboard.png'
                    )
                  "
                  alt="Present with greater ability with live streaming whiteboards."
                />

                <p class="mt-[25px] text-center text-lg text-white">
                  Enrich the presentation by drawing a mind map, or simply
                  writing descriptive annotations to drive the point home!
                </p>
              </div>
              <div
                class="download-card-4"
                v-bind:class="{
                  hidden: openTab !== 4,
                  'block shadow-xl shadow-[#2d8bff33] rounded-lg p-[30px] py-5 ':
                    openTab === 4
                }"
              >
                <img
                  class="p-[20px]"
                  :src="
                    $filters.media_path(
                      '/images/live-offers-on-webinars-sell-live-to-members.png'
                    )
                  "
                  alt="Sell love to members with an offer pop-up."
                />

                <p class="mt-[25px] text-center text-lg text-white">
                  Convert your webinars into full-fledged money-making events
                  with live offer displays.
                </p>
              </div>

              <div
                class="hide-course-card-5"
                v-bind:class="{
                  hidden: openTab !== 5,
                  'block shadow-xl shadow-[#2d8bff33] rounded-lg p-[30px] py-5 ':
                    openTab === 5
                }"
              >
                <img
                  class="p-[20px]"
                  :src="
                    $filters.media_path(
                      '/images/email-reminders-for-webinars.png'
                    )
                  "
                  alt="Easy email reminders for live shows."
                />

                <p class="mt-[25px] text-center text-lg text-white">
                  Ensure great attendance rates with email reminders guaranteed
                  to redirect registers to the show.
                </p>
              </div>

              <div
                class="unlock-course-card-6"
                v-bind:class="{
                  hidden: openTab !== 6,
                  'block shadow-xl shadow-[#2d8bff33] rounded-lg p-[30px] py-5 ':
                    openTab === 6
                }"
              >
                <img
                  class="p-[20px]"
                  :src="
                    $filters.media_path(
                      '/images/downloadable-replays-of-the-live-stream.png'
                    )
                  "
                  alt="Get a downloadable replay of live streams for members."
                />

                <p class="mt-[25px] text-center text-lg text-white">
                  If you activate the option, Platforma will automatically
                  record your live broadcast in a video file for download and
                  use.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--  FEATURES TABS END  -->
</template>

<!-- SCRIPTS -->

<script>
export default {
  name: 'pink-tabs',
  data() {
    return {
      openTab: 1
    };
  },

  methods: {
    toggleTabs: function (tabNumber) {
      this.openTab = tabNumber;
    }
  }
};
</script>

<!-- STYLES -->

<style>
.your-way-tab {
  background-image: url(../media/images/two-dots.svg);
  background-size: auto;
  background-position: center;
}
.quiz-card-1 {
  background-image: url(../media/images/two-dots.svg),
    linear-gradient(to right, #2d8cff, #2d8bffa6);
  background-size: contain;
}
.watch-card-2 {
  background-image: url(../media/images/two-dots.svg),
    linear-gradient(to right, #fd71af, #fd71afa6);
  background-size: contain;
}
.cert-card-3 {
  background-image: url(../media/images/two-dots.svg),
    linear-gradient(to right, #49ccf9, #49ccf9a6);
  background-size: contain;
}
.download-card-4 {
  background-image: url(../media/images/two-dots.svg),
    linear-gradient(to right, #27ae60, #27ae60a6);
  background-size: contain;
}
.hide-course-card-5 {
  background-image: url(../media/images/two-dots.svg),
    linear-gradient(to right, #ffc800, #ffc800a6);
  background-size: contain;
}
.unlock-course-card-6 {
  background-image: url(../media/images/two-dots.svg),
    linear-gradient(to right, #7b68ee, #7b68eea6);
  background-size: contain;
}
.track-member-card-7 {
  background-image: url(../media/images/two-dots.svg),
    linear-gradient(to right, #2d8cff, #2d8bffa6);
  background-size: contain;
}
.unlimited-card-8 {
  background-image: url(../media/images/two-dots.svg),
    linear-gradient(to right, #49ccf9, #49ccf9a6);
  background-size: contain;
}
.data-card-9 {
  background-image: url(../media/images/two-dots.svg),
    linear-gradient(to right, #27ae60, #27ae60a6);
  background-size: contain;
}
.funnel-card-10 {
  background-image: url(../media/images/two-dots.svg),
    linear-gradient(to right, #ffc800, #ffc800a6);
  background-size: contain;
}
</style>
